export default __webpack_public_path__ + "static/media/img-5.1f965469.png";